import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import Footer from '../Footer';
import "../homepagepackage/homepagepackage.css";

import { Button } from '@mui/material';
import { Collapse, ListGroup, ListGroupItem } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as environment from '../../coreservices/environment'

const InnerPackage = () => {


    const [PackageData, setPackageData] = useState([]);

    useEffect(() => {
        getPackageMaster()
    }, [])

    const getPackageMaster = async () => {
        try {
            const response = await fetch(`${environment.apiUrl}/packagemaster`); // Replace with your API endpoint
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const fetched_packagemaster = await response.json();
            setPackageData(fetched_packagemaster);
            console.log('====================================');
            console.log("fetched_packagemaster", fetched_packagemaster);
            console.log('====================================');
        } catch (error) {
            console.error(error.message);
        }
    }


    const [open, setOpen] = useState(false);
    const [openSecond, setOpenSecond] = useState(false);
    const [openThird, setOpenThird] = useState(false);
    const [openFourth, setOpenFourth] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    const updateMedia = () => {
        setIsMobile(window.innerWidth <= 767);
    };

    useEffect(() => {
        window.addEventListener('resize', updateMedia);
        return () => window.removeEventListener('resize', updateMedia);
    });

    const history = useHistory();

    const location = useLocation();

    console.log('====================================');
    console.log("location", location);
    console.log("location?.state?.state?.name", location?.state?.state?.name);
    console.log("location?.state?.state?.email", location?.state?.state?.email);
    console.log("location?.state?.state?.mobile", location?.state?.state?.mobile);
    console.log("location?.state?.state?.userId", location?.state?.state?.userId);
    console.log("location?.state?.state?.fromPage", location?.state?.state?.fromPage);

    console.log("location?.state?.state?.test_of_title", location?.state?.state?.test_of_title);

    console.log('====================================');

    const [form, setForm] = React.useState({
        name: location?.state?.state?.name ? location?.state?.state?.name : "",
        email: location?.state?.state?.email ? location?.state?.state?.email : "",
        amount: location?.state?.state?.amount ? location?.state?.state?.amount : 0,
        mobile: location?.state?.state?.mobile ? location?.state?.state?.mobile : "",
        userId: location?.state?.state?.userId ? location?.state?.state?.userId : "",
        fromPage: location?.state?.state?.fromPage ? location?.state?.state?.fromPage : "",
        test_of_title: location?.state?.state?.test_of_title ? location?.state?.state?.test_of_title : "",
    });

    return (
        <div
            className="section section-1"
            style={{
                paddingTop: '0px'
            }}
        >
            <div className="container">
                {/* <style
                dangerouslySetInnerHTML={{
                    __html: '@media (min-width: 767px) {  .collapse.dont-collapse-sm {    display: block;    height: auto !important;    visibility: visible;  }  }@media only screen and (max-width: 767px) {.btnBox{width:54%;margin: 0 auto;}.col-md-7mobile{text-align:center;}.col-md-5mobile{text-align:center;}.pkgPrices{margin-left:0px !important;text-align:center;border: solid 1px #00B6B1;border-radius: 5px;background: #d4d4d4;padding: 10px;}.ph2{display:block;text-align:center;font-size:18px !important;font-weight:500;color:#000;}.ph1{display:block;text-align:center;font-size:34px !important;font-weight:500;color:#00B6B1;}.pfulldiv{width:100% !important;}.pboxgray1{min-height:55px !important;}.pboxgray2{min-height:55px !important;}.pboxwhite1{min-height:150px !important;}.pboxwhite2{min-height:150px !important;}.pp1{padding:5px 10px;font-size:16px !important;}.ppkgbox1{min-height:330px !important;margin:5px;10px;padding:0px;border:solid 3px #d4d4d4;border-radius:10px;}}.pp1{padding:5px 10px;font-size:22px;}.ppkgbox1{min-height:530px;margin:5px;10px;padding:0px;border:solid 3px #d4d4d4;border-radius:10px;}.pfulldiv{width:33%;}.pboxgray1{background:#d4d4d4;background: #d4d4d4;min-height:354px;font-size: 20px;font-weight: 600;text-align: center;padding-top: 169px;}.pboxgray2{background:#d4d4d4;background: #d4d4d4;min-height:257px;font-size: 20px;font-weight: 600;text-align: center;padding-top: 93px;}.pboxwhite1{color:#00CBC5;background:#FFF;min-height:256px;font-size: 20px;font-weight: 600;text-align: center;padding-top: 100px;}.pboxwhite2{color:#00CBC5;background:#FFF;min-height:256px;font-size: 20px;font-weight: 600;text-align: center;padding-top: 80px;}.ph1{display:block;text-align:center;font-size:46px;font-weight:600;color:#00B6B1;}.ph2{display:block;text-align:center;font-size:24px;font-weight:500;color:#000;}.tick{color: white;background: #00B6B1;padding: 3px 5px;border-radius: 5px;}.cross{color: white;background: #F66666;padding: 3px 5px;border-radius: 5px;}.pkgdetails li{padding:5px 15px;}.pkgPrices{margin-left:24%;text-align:center;border: solid 1px #00B6B1;border-radius: 5px;background: #d4d4d4;padding: 10px;}.pkgDuration{margin-left:10px;text-align:center;border: solid 1px #d4d4d4;border-radius: 5px;background: #d4d4d4;padding: 40px;}.col-md-5mobile{text-align:center;}.btn_pkg {background: #3498db;background-image: -webkit-linear-gradient(top, #3498db, #2980b9);background-image: -moz-linear-gradient(top, #3498db, #2980b9);background-image: -ms-linear-gradient(top, #3498db, #2980b9);background-image: -o-linear-gradient(top, #3498db, #2980b9);background-image: linear-gradient(to bottom, #3498db, #2980b9);-webkit-border-radius: 10;-moz-border-radius: 10;border-radius: 10px;font-family: Arial;color: #ffffff;padding: 10px 20px 10px 20px;border: solid #1f628d 2px;text-decoration: none;}.btn_pkg:hover {background: #3cb0fd;background-image: -webkit-linear-gradient(top, #3cb0fd, #3498db);background-image: -moz-linear-gradient(top, #3cb0fd, #3498db);background-image: -ms-linear-gradient(top, #3cb0fd, #3498db);background-image: -o-linear-gradient(top, #3cb0fd, #3498db);background-image: linear-gradient(to bottom, #3cb0fd, #3498db);text-decoration: none;}.pricing-span {text-align: center;display: block;width: 144px;padding: 10px;color: #ffffff;font-weight: bold;font-size: large;min-height: 36px;margin: 0 auto;}'
                }}
            /> */}
                <style
                    dangerouslySetInnerHTML={{
                        __html: `
                @media (min-width: 767px) {  
                    .collapse.dont-collapse-sm {
                        display: block;
                        height: auto !important;
                        visibility: visible;  
                    }
                }

                @media only screen and (max-width: 767px) {
                    .btnBox {
                        width: 54%;
                        margin: 0 auto;
                    }
                    .col-md-7mobile, .col-md-5mobile {
                        text-align: center;
                    }
                    .pkgPrices {
                        margin-left: 0px !important;
                        text-align: center;
                        border: solid 1px #00B6B1;
                        border-radius: 5px;
                        background: #d4d4d4;
                        padding: 10px;
                    }
                    .ph2 {
                        display: block;
                        text-align: center;
                        font-size: 18px !important;
                        font-weight: 500;
                        color: #000;
                    }
                    .ph1 {
                        display: block;
                        text-align: center;
                        font-size: 34px !important;
                        font-weight: 500;
                        color: #00B6B1;
                    }
                    .pfulldiv {
                        width: 100% !important;
                    }
                    .pboxgray1, .pboxgray2, .pboxwhite1, .pboxwhite2 {
                        min-height: 55px !important;
                    }
                    .pboxwhite1, .pboxwhite2 {
                        min-height: 150px !important;
                    }
                    .pp1 {
                        padding: 5px 10px;
                        font-size: 16px !important;
                    }
                    .ppkgbox1 {
                        min-height: 330px !important;
                        margin: 5px 10px;
                        padding: 0px;
                        border: solid 3px #d4d4d4;
                        border-radius: 10px;
                    }
                }

                .pp1 {
                    padding: 5px 10px;
                    font-size: 22px;
                }
                .ppkgbox1 {
                    min-height: 530px;
                    margin: 5px 10px;
                    padding: 0px;
                    border: solid 3px #d4d4d4;
                    border-radius: 10px;
                }
                .pfulldiv {
                    width: 33%;
                }
                .pboxgray1 {
                    background: #d4d4d4;
                    min-height: 354px;
                    font-size: 20px;
                    font-weight: 600;
                    text-align: center;
                    padding-top: 169px;
                }
                .pboxgray2 {
                    background: #d4d4d4;
                    min-height: 257px;
                    font-size: 20px;
                    font-weight: 600;
                    text-align: center;
                    padding-top: 93px;
                }
                .pboxwhite1, .pboxwhite2 {
                    color: #00CBC5;
                    background: #FFF;
                    min-height: 256px;
                    font-size: 20px;
                    font-weight: 600;
                    text-align: center;
                    padding-top: 100px;
                }
                .pboxwhite2 {
                    padding-top: 80px;
                }
                .ph1 {
                    display: block;
                    text-align: center;
                    font-size: 46px;
                    font-weight: 600;
                    color: #00B6B1;
                }
                .ph2 {
                    display: block;
                    text-align: center;
                    font-size: 24px;
                    font-weight: 500;
                    color: #000;
                }
                .tick {
                    color: white;
                    background: #00B6B1;
                    padding: 3px 5px;
                    border-radius: 5px;
                }
                .cross {
                    color: white;
                    background: #F66666;
                    padding: 3px 5px;
                    border-radius: 5px;
                }
                .pkgdetails li {
                    padding: 5px 15px;
                }
                .pkgPrices {
                    margin-left: 24%;
                    text-align: center;
                    border: solid 1px #00B6B1;
                    border-radius: 5px;
                    background: #d4d4d4;
                    padding: 10px;
                }
                .pkgDuration {
                    margin-left: 10px;
                    text-align: center;
                    border: solid 1px #d4d4d4;
                    border-radius: 5px;
                    background: #d4d4d4;
                    padding: 40px;
                }
                .btn_pkg {
                    background: #3498db;
                    background-image: linear-gradient(to bottom, #3498db, #2980b9);
                    border-radius: 10px;
                    font-family: Arial;
                    color: #ffffff;
                    padding: 10px 20px;
                    border: solid #1f628d 2px;
                    text-decoration: none;
                }
                .btn_pkg:hover {
                    background: #3cb0fd;
                    background-image: linear-gradient(to bottom, #3cb0fd, #3498db);
                    text-decoration: none;
                }
                .pricing-span {
                    text-align: center;
                    display: block;
                    width: 144px;
                    padding: 10px;
                    color: #ffffff;
                    font-weight: bold;
                    font-size: large;
                    min-height: 36px;
                    margin: 0 auto;
                }

                .tick {
                    color: white;
                    background: #00b6b1;
                    padding: 3px 5px;
                    border-radius: 5px;
                  }
                  
                  .hidden {
                    display: block;
                    visibility: visible;
                  }
                  
                  .visible-xs {
                    display: block;
                  }
                  
                  .pkgdetails {
                    list-style: none;
                    padding: 0;
                  }
                  
                  .pkgdetails li {
                    padding: 5px 15px;
                  }
                
                  
            `,
                    }}
                />


            </div>
            <div
                className="section"
                style={{
                    // background: '#fff',
                    fontFamily: 'arail',
                    padding: 10
                }}
            >
                <div
                    className="container"
                    style={{}}
                >
                    <span className="ph1">
                        MEMBERSHIP PACKAGES
                    </span>
                    <span className="ph2">
                        4 Convenient Premium Packages to Choose From!
                    </span>
                </div>
                <div
                    className="msg-box info-box rounded"
                    style={{
                        background: '#00CBC5',
                        textAlign: 'center'
                    }}
                >
                    {/* <a
                    className="close fa fa-times"
                    href="#"
                /> */}
                    <p>
                        <span
                            style={{
                                color: '#fff',
                                fontSize: '28px',
                                fontWeight: 'bold'
                            }}
                        >
                            Discount Upto 40% Valid Till July 30th
                        </span>
                    </p>
                </div>
                <div
                    className=""
                    style={{
                        // background: '#fff'
                    }}
                >
                    <div
                        className="section"
                        style={{
                            // backgroundColor: '#fff',
                            fontFamily: 'sans-serif',
                            fontSize: '105%',
                            margin: '2px 10%'
                        }}
                    >






                        <div className="d-flex justify-content-between flex-wrap">
                            <div className="col-md-4">
                                <div
                                    style={{
                                        clear: 'both'
                                    }}
                                >
                                </div>
                                <div className="ppkgbox1">
                                    <span
                                        style={{
                                            background: '#d4d4d4',
                                            display: 'block',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            padding: '10px',
                                            textAlign: 'center',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        {/* basic(price-99) MEMBERSHIP{' '} */}
                                        {PackageData[0]?.packageName}(price-{PackageData[0]?.packagePrice}) MEMBERSHIP{' '}
                                    </span>
                                    <br />
                                    <div className="col-md-12 col-md-7mobile">
                                        <div className="col-md-6 pkgPrices">
                                            <strong>
                                                <span
                                                    style={{
                                                        color: '#00B6B1',
                                                        display: 'block',
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    15% off
                                                </span>
                                                <span
                                                    className=""
                                                    style={{
                                                        color: '#F20000',
                                                        fontSize: '20px',
                                                        fontWeight: '600',
                                                        lineHeight: '20px'
                                                    }}
                                                >
                                                    <b
                                                        style={{
                                                            color: '#F38787',
                                                            fontSize: '13px',
                                                            textDecoration: 'line-through'
                                                        }}
                                                    >
                                                        {' '}₹999
                                                    </b>
                                                    {' '}
                                                    <br />
                                                    ₹{PackageData[0]?.packagePrice}
                                                    <br />
                                                    <span
                                                        style={{
                                                            color: '#F20000',
                                                            fontSize: '12px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        (US $1.36)
                                                    </span>
                                                </span>
                                            </strong>
                                            <br />
                                            <span
                                                style={{
                                                    fontSize: '12px'
                                                }}
                                            >
                                                Membership for {PackageData[0]?.packageValidity} month{' '}
                                            </span>
                                        </div>
                                        <br />
                                        <div
                                            style={{
                                                background: '#00B3AF',
                                                color: '#fff',
                                                display: 'none',
                                                fontSize: '10px',
                                                marginBottom: '5px',
                                                padding: '5px',
                                                position: 'relative'
                                            }}
                                        >
                                            Coupon# 24hour-special-offer
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12 col-md-7mobile">
                                    <a
                                        aria-controls="collapseExample"
                                        aria-expanded="false"
                                        className=" hidden visible-xs"
                                        data-target="#collapseExample3"
                                        data-toggle="collapse"
                                        href="javascript:void(0)"
                                    >
                                        {' '}Package Details 🔽
                                    </a>
                                    <div
                                        className="collapse dont-collapse-sm"
                                        id="collapseExample3"
                                    >
                                        <ul className="pkgdetails">
                                            <br />
                                            <li>
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                <span style={{}}>

                                                </span>
                                                {' '}Suscription for 1 month(validity)
                                            </li>

                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}Send unlimited Messages(will add){' '}
                                            </li>
                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}View upto 3 Contact Numbers{' '}
                                            </li>
                                            <li>
                                                {' '}
                                              
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}Any 2 TYS can be downloaded{' '}
                                            </li>
                                        </ul>
                                        <br />
                                    </div>
                                </div> */}

                                    {/* <div className="col-md-12 col-md-7mobile">
  <a
    aria-controls="collapseExample3"
    aria-expanded="false"
    className="hidden visible-xs"
    data-target="#collapseExample3"
    data-toggle="collapse"
    href="#collapseExample3"
  >
    Package Details 🔽
  </a>
  <div className="collapse dont-collapse-sm" id="collapseExample3">
    <ul className="pkgdetails">
      <br />
      <li>
        <span className="tick">✔</span> Subscription for 1 month (validity)
      </li>
      <li>
        <span className="tick">✔</span> Send unlimited Messages (will add)
      </li>
      <li>
        <span className="tick">✔</span> View up to 3 Contact Numbers
      </li>
      <li>
        <span className="tick">✔</span> Any 2 TYS can be downloaded
      </li>
    </ul>
    <br />
  </div>
</div> */}

                                    <div className="col-md-12 col-md-7mobile">
                                        {isMobile ? (
                                            <Button
                                                onClick={() => setOpen(!open)}
                                                aria-controls="collapseExample3"
                                                aria-expanded={open}
                                                className="hidden visible-xs"
                                            >
                                                Package Details 🔽
                                            </Button>
                                        ) :

                                            <a
                                                aria-controls="collapseExample"
                                                aria-expanded="false"
                                                className=" hidden visible-xs"
                                                data-target="#collapseExample3"
                                                data-toggle="collapse"
                                                href="javascript:void(0)"
                                            >
                                                {' '}Package Details 🔽
                                            </a>

                                        }
                                        <Collapse in={open || !isMobile}>
                                            <div id="collapseExample3">
                                                <ListGroup>
                                                    <br />
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Subscription for {PackageData[0]?.packageValidity} month (validity)
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Send unlimited Messages (will add)
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> View up to {PackageData[0]?.packageMobileAvailable} Contact Numbers
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Any {PackageData[0]?.packageTYSAvailable} TYS can be downloaded
                                                    </ListGroupItem>
                                                </ListGroup>
                                                <br />
                                            </div>
                                        </Collapse>
                                    </div>

                                    <div className="col-md-12 col-md-5mobile">
                                        <div className="row btnBox">



                                            <div
                                                className="col-md-12"
                                                style={{
                                                    paddingLeft: '17px',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {/* <form
                                                // action="https://www.shadi.com/cc_payment.htm?tocken_url=?token=NjQxNTkxZmU0NmM5NjYzNmZjOTQ1NjBkNDZkYjcwZjk"
                                                id="payment_frm"
                                                method="post"
                                                name="payment_frm"
                                            > */}
                                                <input
                                                    defaultValue="24hour-special-offer"
                                                    name="coupon_code"
                                                    type="hidden"
                                                />
                                                <input
                                                    defaultValue="cc"
                                                    name="pay_method"
                                                    type="hidden"
                                                />
                                                <input
                                                    defaultValue="1"
                                                    name="membership"
                                                    type="hidden"
                                                />
                                                <div
                                                    // name="action"
                                                    style={{
                                                        background: '#00CBC5',
                                                        borderRadius: '10px',
                                                        color: '#FFF',
                                                        display: 'block',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        padding: '10px',
                                                        textAlign: 'center',
                                                        width: '100%',
                                                        cursor: 'pointer'
                                                    }}
                                                    // type="submit"
                                                    // value="PAY NOW"
                                                    onClick={
                                                        // () => handleOpenTest()}
                                                        () => { history.push('/PayUMoneyform', { state: { name: form.name, mobile: form.mobile, email: form.email, amount: PackageData[0]?.packagePrice, fromPage: form.fromPage, test_of_title: form.test_of_title, PackageData: PackageData[0] } }) }
                                                    }
                                                >PAY NOW</div>
                                                {/* </form> */}

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div
                                    style={{
                                        clear: 'both'
                                    }}
                                >
                                </div>
                                <div className="ppkgbox1">
                                    <span
                                        style={{
                                            background: '#d4d4d4',
                                            display: 'block',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            padding: '10px',
                                            textAlign: 'center',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        {PackageData[1]?.packageName}(PRICE-{PackageData[1]?.packagePrice}) MEMBERSHIP{' '}
                                    </span>
                                    <br />
                                    <div className="col-md-12 col-md-7mobile">
                                        <div className="col-md-6 pkgPrices">
                                            <strong>
                                                <span
                                                    style={{
                                                        color: '#00B6B1',
                                                        display: 'block',
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    20% off
                                                </span>
                                                <span
                                                    className=""
                                                    style={{
                                                        color: '#F20000',
                                                        fontSize: '20px',
                                                        fontWeight: '600',
                                                        lineHeight: '20px'
                                                    }}
                                                >
                                                    <b
                                                        style={{
                                                            color: '#F38787',
                                                            fontSize: '13px',
                                                            textDecoration: 'line-through'
                                                        }}
                                                    >
                                                        {' '}₹1249
                                                    </b>
                                                    {' '}
                                                    <br />
                                                    ₹{PackageData[1]?.packagePrice}
                                                    <br />
                                                    <span
                                                        style={{
                                                            color: '#F20000',
                                                            fontSize: '12px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        (US $3.41)
                                                    </span>
                                                </span>
                                            </strong>
                                            <br />
                                            <span
                                                style={{
                                                    fontSize: '12px'
                                                }}
                                            >
                                                Membership for {PackageData[1]?.packageValidity} months{' '}
                                            </span>
                                        </div>
                                        <br />
                                        <div
                                            style={{
                                                background: '#00B3AF',
                                                color: '#fff',
                                                display: 'none',
                                                fontSize: '10px',
                                                marginBottom: '5px',
                                                padding: '5px',
                                                position: 'relative'
                                            }}
                                        >
                                            Coupon# 24hour-special-offer
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12 col-md-7mobile">
                                    <a
                                        aria-controls="collapseExample"
                                        aria-expanded="false"
                                        className=" hidden visible-xs"
                                        data-target="#collapseExample4"
                                        data-toggle="collapse"
                                        href="javascript:void(0)"
                                    >
                                        {' '}Package Details 🔽
                                    </a>
                                    <div
                                        className="collapse dont-collapse-sm"
                                        id="collapseExample4"
                                    >
                                        <ul className="pkgdetails">
                                            <br />
                                            <li>
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                <span style={{}}>

                                                </span>
                                                {' '}Suscription for 3 month(validity)
                                            </li>

                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}Send unlimited Messages(will add){' '}
                                            </li>
                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}View upto 6 Contact Numbers{' '}
                                            </li>
                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}Any 3 TYS can be downloaded{' '}
                                            </li>
                                        </ul>
                                        <br />
                                    </div>
                                </div> */}



                                    <div className="col-md-12 col-md-7mobile">
                                        {isMobile ? (
                                            <Button
                                                onClick={() => setOpenSecond(!openSecond)}
                                                aria-controls="collapseExample4"
                                                aria-expanded={openSecond}
                                                className="hidden visible-xs"
                                            >
                                                Package Details 🔽
                                            </Button>
                                        ) :
                                            <a
                                                aria-controls="collapseExample"
                                                aria-expanded="false"
                                                className=" hidden visible-xs"
                                                data-target="#collapseExample3"
                                                data-toggle="collapse"
                                                href="javascript:void(0)"
                                            >
                                                {' '}Package Details 🔽
                                            </a>
                                        }
                                        <Collapse in={openSecond || !isMobile}>
                                            <div id="collapseExample4">
                                                <ListGroup>
                                                    <br />
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Subscription for {PackageData[1]?.packageValidity} months (validity)
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Send unlimited Messages (will add)
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> View up to {PackageData[1]?.packageMobileAvailable} Contact Numbers
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Any {PackageData[1]?.packageTYSAvailable} TYS can be downloaded
                                                    </ListGroupItem>
                                                </ListGroup>
                                                <br />
                                            </div>
                                        </Collapse>
                                    </div>


                                    <div className="col-md-12 col-md-5mobile">
                                        <div className="row btnBox">
                                            <div
                                                className="col-md-12"
                                                style={{
                                                    paddingLeft: '17px',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {/* <form
                                                // action="https://www.shadi.com/cc_payment.htm?tocken_url=?token=NjQxNTkxZmU0NmM5NjYzNmZjOTQ1NjBkNDZkYjcwZjk"
                                                id="payment_frm"
                                                method="post"
                                                name="payment_frm"
                                            > */}
                                                <input
                                                    defaultValue="24hour-special-offer"
                                                    name="coupon_code"
                                                    type="hidden"
                                                />
                                                <input
                                                    defaultValue="cc"
                                                    name="pay_method"
                                                    type="hidden"
                                                />
                                                <input
                                                    defaultValue="1"
                                                    name="membership"
                                                    type="hidden"
                                                />
                                                <div
                                                    // name="action"
                                                    style={{
                                                        background: '#00CBC5',
                                                        borderRadius: '10px',
                                                        color: '#FFF',
                                                        display: 'block',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        padding: '10px',
                                                        textAlign: 'center',
                                                        width: '100%',
                                                        cursor: 'pointer'
                                                    }}
                                                    // type="submit"
                                                    // value="PAY NOW"
                                                    onClick={
                                                        // () => handleOpenTest()}
                                                        () => { history.push('/PayUMoneyform', { state: { name: form.name, mobile: form.mobile, email: form.email, amount: PackageData[1]?.packagePrice, fromPage: form.fromPage, test_of_title: form.test_of_title, PackageData: PackageData[1] } }) }}

                                                >PAY NOW</div>
                                                {/* </form> */}

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div
                                    style={{
                                        clear: 'both'
                                    }}
                                >
                                </div>
                                <div className="ppkgbox1">
                                    <span
                                        style={{
                                            background: '#d4d4d4',
                                            display: 'block',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            padding: '10px',
                                            textAlign: 'center',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        {PackageData[2]?.packageName}(price-{PackageData[2]?.packagePrice}) MEMBERSHIP{' '}
                                    </span>
                                    <br />
                                    <div className="col-md-12 col-md-7mobile">
                                        <div className="col-md-6 pkgPrices">
                                            <strong>
                                                <span
                                                    style={{
                                                        color: '#00B6B1',
                                                        display: 'block',
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    26% off
                                                </span>
                                                <span
                                                    className=""
                                                    style={{
                                                        color: '#F20000',
                                                        fontSize: '20px',
                                                        fontWeight: '600',
                                                        lineHeight: '20px'
                                                    }}
                                                >
                                                    <b
                                                        style={{
                                                            color: '#F38787',
                                                            fontSize: '13px',
                                                            textDecoration: 'line-through'
                                                        }}
                                                    >
                                                        {' '}₹2499
                                                    </b>
                                                    {' '}
                                                    <br />
                                                    ₹{PackageData[2]?.packagePrice}
                                                    <br />
                                                    <span
                                                        style={{
                                                            color: '#F20000',
                                                            fontSize: '12px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        (US $6.84)
                                                    </span>
                                                </span>
                                            </strong>
                                            <br />
                                            <span
                                                style={{
                                                    fontSize: '12px'
                                                }}
                                            >
                                                Membership for {PackageData[2]?.packageValidity} months{' '}
                                            </span>
                                        </div>
                                        <br />
                                        <div
                                            style={{
                                                background: '#00B3AF',
                                                color: '#fff',
                                                display: 'none',
                                                fontSize: '10px',
                                                marginBottom: '5px',
                                                padding: '5px',
                                                position: 'relative'
                                            }}
                                        >
                                            Coupon# 24hour-special-offer
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12 col-md-7mobile">
                                    <a
                                        aria-controls="collapseExample"
                                        aria-expanded="false"
                                        className=" hidden visible-xs"
                                        data-target="#collapseExample5"
                                        data-toggle="collapse"
                                        href="javascript:void(0)"
                                    >
                                        {' '}Package Details 🔽
                                    </a>
                                    <div
                                        className="collapse dont-collapse-sm"
                                        id="collapseExample5"
                                    >
                                        <ul className="pkgdetails">
                                            <br />
                                            <li>
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                <span style={{}}>

                                                </span>
                                                {' '}Suscription for 5 month(validity)
                                            </li>

                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}Send unlimited Messages(will add){' '}
                                            </li>
                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}View upto 10 Contact Numbers{' '}
                                            </li>
                                            <li>
                                                {' '}
                                                <span className="tick">
                                                    ✔
                                                </span>
                                                {' '}Any 50 TYS can be downloaded{' '}
                                            </li>
                                        </ul>
                                        <br />
                                    </div>
                                </div> */}

                                    <div className="col-md-12 col-md-7mobile">
                                        {isMobile ? (
                                            <Button
                                                onClick={() => setOpenThird(!openThird)}
                                                aria-controls="collapseExample5"
                                                aria-expanded={openThird}
                                                className="hidden visible-xs"
                                            >
                                                Package Details 🔽
                                            </Button>
                                        ) :
                                            <a
                                                aria-controls="collapseExample"
                                                aria-expanded="false"
                                                className=" hidden visible-xs"
                                                data-target="#collapseExample5"
                                                data-toggle="collapse"
                                                href="javascript:void(0)"
                                            >
                                                {' '}Package Details 🔽
                                            </a>
                                        }
                                        <Collapse in={openThird || !isMobile}>
                                            <div id="collapseExample5">
                                                <ListGroup>
                                                    <br />
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Subscription for {PackageData[2]?.packageValidity} months (validity)
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Send unlimited Messages (will add)
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> View up to {PackageData[2]?.packageMobileAvailable} Contact Numbers
                                                    </ListGroupItem>
                                                    <ListGroupItem>
                                                        <span className="tick">✔</span> Any {PackageData[2]?.packageTYSAvailable} TYS can be downloaded
                                                    </ListGroupItem>
                                                </ListGroup>
                                                <br />
                                            </div>
                                        </Collapse>
                                    </div>


                                    <div className="col-md-12 col-md-5mobile">
                                        <div className="row btnBox">
                                            <div
                                                className="col-md-12"
                                                style={{
                                                    paddingLeft: '17px',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {/* <form
                                                // action="https://www.shadi.com/cc_payment.htm?tocken_url=?token=NjQxNTkxZmU0NmM5NjYzNmZjOTQ1NjBkNDZkYjcwZjk"
                                                id="payment_frm"
                                                method="post"
                                                name="payment_frm"
                                            > */}
                                                <input
                                                    defaultValue="24hour-special-offer"
                                                    name="coupon_code"
                                                    type="hidden"
                                                />
                                                <input
                                                    defaultValue="cc"
                                                    name="pay_method"
                                                    type="hidden"
                                                />
                                                <input
                                                    defaultValue="1"
                                                    name="membership"
                                                    type="hidden"
                                                />
                                                <div
                                                    // name="action"
                                                    style={{
                                                        background: '#00CBC5',
                                                        borderRadius: '10px',
                                                        color: '#FFF',
                                                        display: 'block',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        padding: '10px',
                                                        textAlign: 'center',
                                                        width: '100%',
                                                        cursor: 'pointer'
                                                    }}
                                                    // type="submit"
                                                    // value="PAY NOW"
                                                    onClick={
                                                        // () => handleOpenTest()}

                                                        () => { history.push('/PayUMoneyform', { state: { name: form.name, mobile: form.mobile, email: form.email, amount: PackageData[2]?.packagePrice, fromPage: form.fromPage, test_of_title: form.test_of_title, PackageData: PackageData[2] } }) }}
                                                >PAY NOW</div>
                                                {/* </form> */}

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>

                        <div className="col-md-12">
                            <div
                                className="pfulldiv"
                                style={{
                                    border: 'solid 3px #d4d4d4',
                                    borderRadius: '10px',
                                    margin: '0 auto',
                                    minHeight: '330px',
                                    padding: '0px'
                                }}
                            >
                                <span
                                    style={{
                                        background: '#d4d4d4',
                                        display: 'block',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        padding: '10px',
                                        textAlign: 'center',
                                        textTransform: 'uppercase'
                                    }}
                                >
                                    {PackageData[3]?.packageName}(price-{PackageData[3]?.packagePrice}){' '}
                                </span>
                                <br />
                                <div className="col-md-12 col-md-7mobile">
                                    <div className="col-md-6 pkgPrices">
                                        <strong>
                                            <span
                                                style={{
                                                    color: '#00B6B1',
                                                    display: 'block',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                40% off
                                            </span>
                                            <span
                                                className=""
                                                style={{
                                                    color: '#F20000',
                                                    fontSize: '20px',
                                                    fontWeight: '600',
                                                    lineHeight: '20px'
                                                }}
                                            >
                                                <b
                                                    style={{
                                                        color: '#F38787',
                                                        fontSize: '13px',
                                                        textDecoration: 'line-through'
                                                    }}
                                                >
                                                    {' '}₹3999
                                                </b>
                                                {' '}
                                                <br />
                                                ₹{PackageData[3]?.packagePrice}
                                                <br />
                                                <span
                                                    style={{
                                                        color: '#F20000',
                                                        fontSize: '12px',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    (US $13.66)
                                                </span>
                                            </span>
                                        </strong>
                                        <br />
                                        <span
                                            style={{
                                                fontSize: '12px'
                                            }}
                                        >
                                            Membership for {PackageData[3]?.packageValidity} months{' '}
                                        </span>
                                    </div>
                                </div>
                                {/* <div className="col-md-12 col-md-7mobile">
                                <a
                                    aria-controls="collapseExample"
                                    aria-expanded="false"
                                    className=" hidden visible-xs"
                                    data-target="#collapseExample6"
                                    data-toggle="collapse"
                                    href="javascript:void(0)"
                                >
                                    {' '}Package Details 🔽
                                </a>
                                <div
                                    className="collapse dont-collapse-sm"
                                    id="collapseExample6"
                                >
                                    <ul className="pkgdetails">
                                        <br />
                                        <li>
                                            <span className="tick">
                                                ✔
                                            </span>
                                            <span style={{}}>

                                            </span>
                                            {' '}Suscription for 1 year(validity)
                                        </li>

                                        <li>
                                            {' '}
                                            <span className="tick">
                                                ✔
                                            </span>
                                            {' '}Send unlimited Messages(will add){' '}
                                        </li>
                                        <li>
                                            {' '}
                                            <span className="tick">
                                                ✔
                                            </span>
                                            {' '}View upto 50 Contact Numbers{' '}
                                        </li>
                                        <li>
                                            {' '}
                                            <span className="tick">
                                                ✔
                                            </span>
                                            {' '}Any 100 TYS can be downloaded{' '}
                                        </li>

                                        <li>
                                            {' '}
                                            <span className="tick">
                                                ✔
                                            </span>
                                            {' '} Let Matches contact you directly{' '}
                                        </li>
                                        <li>
                                            {' '}
                                            <span className="tick">
                                                ✔
                                            </span>
                                            {' '}BEST VALUE{' '}
                                        </li>


                                    </ul>
                                    <br />
                                </div>
                            </div> */}


                                <div className="col-md-12 col-md-7mobile">
                                    {isMobile ? (
                                        <Button
                                            onClick={() => setOpenFourth(!openFourth)}
                                            aria-controls="collapseExample6"
                                            aria-expanded={openFourth}
                                            className="hidden visible-xs"
                                        >
                                            Package Details 🔽
                                        </Button>
                                    ) :
                                        <a
                                            aria-controls="collapseExample"
                                            aria-expanded="false"
                                            className=" hidden visible-xs"
                                            data-target="#collapseExample6"
                                            data-toggle="collapse"
                                            href="javascript:void(0)"
                                        >
                                            {' '}Package Details 🔽
                                        </a>
                                    }
                                    <Collapse in={openFourth || !isMobile}>
                                        <div id="collapseExample6">
                                            <ListGroup>
                                                <br />
                                                <ListGroupItem>
                                                    <span className="tick">✔</span> Subscription for {PackageData[3]?.packageValidity} months (validity)
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <span className="tick">✔</span> Send unlimited Messages (will add)
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <span className="tick">✔</span> View up to {PackageData[3]?.packageMobileAvailable} Contact Numbers
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <span className="tick">✔</span> Any {PackageData[3]?.packageTYSAvailable} TYS can be downloaded
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <span className="tick">✔</span> Let Matches contact you directly
                                                </ListGroupItem>
                                                <ListGroupItem>
                                                    <span className="tick">✔</span> BEST VALUE
                                                </ListGroupItem>
                                            </ListGroup>
                                            <br />
                                        </div>
                                    </Collapse>
                                </div>

                                <div className="col-md-12 col-md-5mobile">
                                    <div className="row btnBox">
                                        <div
                                            className="col-md-12"
                                            style={{
                                                paddingLeft: '17px',
                                                textAlign: 'center'
                                            }}
                                        >
                                            {/* <form
                                                // action="https://www.shadi.com/cc_payment.htm?tocken_url=?token=NjQxNTkxZmU0NmM5NjYzNmZjOTQ1NjBkNDZkYjcwZjk"
                                                id="payment_frm"
                                                method="post"
                                                name="payment_frm"
                                            > */}
                                            <input
                                                defaultValue="24hour-special-offer"
                                                name="coupon_code"
                                                type="hidden"
                                            />
                                            <input
                                                defaultValue="cc"
                                                name="pay_method"
                                                type="hidden"
                                            />
                                            <input
                                                defaultValue="1"
                                                name="membership"
                                                type="hidden"
                                            />
                                            <div
                                                // name="action"
                                                style={{
                                                    background: '#00CBC5',
                                                    borderRadius: '10px',
                                                    color: '#FFF',
                                                    display: 'block',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    padding: '10px',
                                                    textAlign: 'center',
                                                    width: '100%',
                                                    cursor: 'pointer'
                                                }}
                                                // type="submit"
                                                // value="PAY NOW"
                                                onClick={
                                                    // () => handleOpenTest()}
                                                    () => { history.push('/PayUMoneyform', { state: { name: form.name, mobile: form.mobile, email: form.email, amount: PackageData[3]?.packagePrice, fromPage: form.fromPage, test_of_title: form.test_of_title, PackageData: PackageData[3] } }) }}
                                            >PAY NOW</div>
                                            {/* </form> */}

                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>


    )
}

export default InnerPackage
